export default __webpack_public_path__ + "static/media/Inter-Medium.4ebf1acf.ttf";